import React from 'react'
import { t } from 'ttag'

import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { Modal } from 'components/shared/Modal/Modal'
import { ImportCandidatesForm } from './common/ImportCandidatesForm/ImportCandidatesForm'
import { CandidatesPreview } from './common/CandidatesPreview/CandidatesPreview'

import { useImportCandidatesState } from './hooks'

import styles from './ImportCandidatesModal.module.scss'

export const ImportCandidatesModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state, handlers } = useImportCandidatesState(
    { isOpen },
    { onCancel, onClose, onConfirm },
  )

  const {
    data,
    form: { control, formState },
    isConfirmationOpen,
    isPreviewOpen,
  } = state
  const {
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
    handleDownloadTemplate,
    handlePreview,
  } = handlers

  return (
    <React.Fragment>
      <Modal
        className={styles.modal}
        cancelLabel={t`Cancel`}
        confirmLabel={t`Import`}
        title={t`Import candidates`}
        onCancel={handleCancel}
        onClose={handleClose}
        onConfirm={handleConfirm}
        {...{ isOpen }}
      >
        <Modal.Header />
        <Modal.Content className={styles.content}>
          <ImportCandidatesForm {...{ control, formState }} />
          <CandidatesPreview
            onDownloadTemplate={handleDownloadTemplate}
            onPreview={handlePreview}
            {...{ data, isPreviewOpen }}
          />
        </Modal.Content>
        <Modal.Footer />
      </Modal>
      <DoubleConfirmationModal
        onCancel={handleConfirmationClose}
        onClose={handleConfirmationClose}
        onConfirm={handleConfirmationConfirm}
        isOpen={isConfirmationOpen}
      />
    </React.Fragment>
  )
}
